export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ')
}

export const Colors = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
} as const
export type Color = (typeof Colors)[keyof typeof Colors]

export const FontFamily = {
  gothic:
    '"Helvetica Neue",Arial,"Hiragino Kaku Gothic ProN","Hiragino Sans",Meiryo,sans-serif',
  serif:
    '"游明朝", YuMincho, "Hiragino Mincho ProN W3", "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif',
  thisTime:
    '"Noto Sans JP", "sans-serif", cursive, "Yusei Magic", Meiryo,"Hiragino Sans"',
}
